import * as React from "react";
import Toast from "../../helper/Toast";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import FileSelector from "../../file/FileSelector";
import {attachUploadedFilesToJob} from "../../../store/action/job/job";
import AssetUploadHelper from "../../../helper/AssetUploadHelper";

interface IDispatchProps {
	/**
	 * Attach uploaded files to job
	 * @param {string} jobId
	 * @param {string[]} attachmentIds
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	attachUploadedFiles: (jobId: string,
		attachmentIds: string[],
		onSuccess: OnSuccess,
		onFailure: OnFailure) => void;
}

interface IComponentProps {
	/**
	 * Job identifier
	 */
	jobId: string
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Attachment identifiers.
	 */
	attachmentIds: string[];
	/**
	 * Indicates if attachments are attaching to job
	 */
	attachingFiles: boolean;
}

type Props = IComponentProps & IDispatchProps;

class FilesTab extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.onDone = this.onDone.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onUpload = this.onUpload.bind(this);
		this.state = {filesUploading: false, attachmentIds: [], attachingFiles: false}
	}

	render() {
		return (
			<div className={"c-files-tab"}>
				<FileSelector filesUploading={this.state.filesUploading || this.state.attachingFiles}
							  onUpload={this.onUpload}
							  onCancel={this.onCancel}/>
			</div>
		);
	}

	/**
	 * On done button click callback.
	 */
	private onDone() {
		if (this.state.attachmentIds.length > 0) {
			this.setState({attachingFiles: true}, () =>
				this.props.attachUploadedFiles(this.props.jobId,
					this.state.attachmentIds,
					() => {this.setState({attachingFiles: false}, () => { this.onCancel();})},
					() => {Toast.error("Sorry, something went wrong. Try again later.", "Attach attachment to job")})
			)
		}
	}

	private onCancel() {
		this.setState({attachmentIds: []});
	}

	onUpload(files: File[], onRejectFile: (file: File) => void, onUploadSuccess: OnSuccess) {
		if (files.length > 0) this.setState({filesUploading: true});
		AssetUploadHelper.UploadAssets(files, onRejectFile, (attachmentIds) => {
			this.setState({attachmentIds: attachmentIds}, () => {
				this.onAllFinished(onUploadSuccess);
			});
		});
	}


	onAllFinished(onUploadSuccess: OnSuccess) {
		this.setState({filesUploading: false}, () => {
			this.setState({attachingFiles: true},
				() => {
					this.props.attachUploadedFiles(this.props.jobId, this.state.attachmentIds,
						() => {
							this.setState({attachingFiles: false, attachmentIds: []},
								() => {
									onUploadSuccess();
									Toast.success("Files uploaded", "Files uploaded")
								})
						},
						() => {
							this.setState({attachingFiles: false},
								() => Toast.error("Sorry, something went wrong. Try again later.",
									"Attach attachment to job"))
						})
				})
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		attachUploadedFiles: (jobId: string,
			attachmentIds: string[],
			onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(attachUploadedFilesToJob(jobId, attachmentIds, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)(FilesTab);